// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"476a0de1","701":"5782a6b5"}[chunkId] + ".chunk.js";
};